/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ setsRemoved: NonNullable<unknown> }} Progression_Feedback_Too_HardInputs */

const en_us2_progression_feedback_too_hard = /** @type {(inputs: Progression_Feedback_Too_HardInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`That was too much: ${i?.setsRemoved} set fewer on everything next time`)
};

const pt_br2_progression_feedback_too_hard = /** @type {(inputs: Progression_Feedback_Too_HardInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Foi demais: ${i?.setsRemoved} série a menos em tudo na próxima`)
};

const es_419_progression_feedback_too_hard = /** @type {(inputs: Progression_Feedback_Too_HardInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fue demasiado: ${i?.setsRemoved} serie menos en todo la próxima vez`)
};

const pt_pt2_progression_feedback_too_hard = /** @type {(inputs: Progression_Feedback_Too_HardInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Foi demais: menos ${i?.setsRemoved} série em tudo na próxima`)
};

const fr_fr2_progression_feedback_too_hard = /** @type {(inputs: Progression_Feedback_Too_HardInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`C'était trop : ${i?.setsRemoved} série de moins sur tout la prochaine fois`)
};

const de_de2_progression_feedback_too_hard = /** @type {(inputs: Progression_Feedback_Too_HardInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Das war zu viel: nächstes Mal überall ${i?.setsRemoved} Satz weniger`)
};

const it_it2_progression_feedback_too_hard = /** @type {(inputs: Progression_Feedback_Too_HardInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`È stato troppo: ${i?.setsRemoved} serie in meno su tutto la prossima volta`)
};

/**
* | output |
* | --- |
* | "That was too much: {setsRemoved} set fewer on everything next time" |
*
* @param {Progression_Feedback_Too_HardInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progression_feedback_too_hard = /** @type {((inputs: Progression_Feedback_Too_HardInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progression_Feedback_Too_HardInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progression_feedback_too_hard(inputs)
	if (locale === "es-419") return es_419_progression_feedback_too_hard(inputs)
	if (locale === "pt-PT") return pt_pt2_progression_feedback_too_hard(inputs)
	if (locale === "fr-FR") return fr_fr2_progression_feedback_too_hard(inputs)
	if (locale === "de-DE") return de_de2_progression_feedback_too_hard(inputs)
	if (locale === "it-IT") return it_it2_progression_feedback_too_hard(inputs)
	return en_us2_progression_feedback_too_hard(inputs)
});
export { progression_feedback_too_hard as "progression.feedback_too_hard" }